import React from 'react'
import { RootObject } from '../../type';
import './style.less';

const NeedToContact = (props: RootObject["needToContact"]) => {
  return (
    <div className="need_to_contact"
      style={{
        background: `url(${props.backImg})`
      }}
    >
      <div className="need_to_contact_back_color">
        <div className="need_to_contact_wrapper">
          <div className="need_to_contact_title">
            {props.NeedToContactTitle ?? ""}
          </div>
          <div className="need_to_contact_sub_title">
            {props.NeedToContactContent ?? ""}
          </div>
          <div className="need_to_contact_btn_link">
            <a className="need_to_contact_btn" href={props.NeedToContactJumpContent.detailLink}>{props.NeedToContactJumpContent.title ?? ""}</a>

          </div>
        </div>
      </div>
    </div>
  )
}

export default NeedToContact;